"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileAvatar = exports.OrganisationAvatar = void 0;
var organisationAvatar_1 = require("./organisationAvatar");
Object.defineProperty(exports, "OrganisationAvatar", { enumerable: true, get: function () { return __importDefault(organisationAvatar_1).default; } });
var profileAvatar_1 = require("./profileAvatar");
Object.defineProperty(exports, "ProfileAvatar", { enumerable: true, get: function () { return __importDefault(profileAvatar_1).default; } });
//# sourceMappingURL=index.js.map